/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ModelGetAPIListRequest,
  ModelGetAPIListResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class ApiList<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description get api list
   *
   * @tags api
   * @name ApiListCreate
   * @summary get api list
   * @request POST:/apiList
   */
  apiListCreate = (
    request: ModelGetAPIListRequest,
    params: RequestParams = {}
  ) =>
    this.request<ModelGetAPIListResponse, any>({
      path: `/apiList`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
